import { useEffect } from 'react';

/** ⌘K on a Mac, Ctrl+K elsewhere — from anywhere in the signed-in app. */
export function useCommandPaletteShortcut(onOpen: () => void): void {
  useEffect(() => {
    const handle = (event: globalThis.KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        onOpen();
      }
    };
    document.addEventListener('keydown', handle);
    return () => {
      document.removeEventListener('keydown', handle);
    };
  }, [onOpen]);
}
